export default __webpack_public_path__ + "svg/calendar/2027/3/abril.svg?bb5e678b";